import { SET_CHECKOUT } from "../types";

export const setCheckout = (reservationId) => ({
  type: SET_CHECKOUT,
  reservationId,
});
